import React from 'react';
import PropTypes from 'prop-types';

import styles from './cancelPopUp.module.css';

const CancelAppointmentPopUp = ({ toggleClick, closePopUp }) => (
  <div className={styles.outerContainer}>
    <div className={styles.container}>
      <div className={styles.text}>
        Are you sure you want to cancel this appointment?
      </div>
      <div className={styles.buttonContainer}>
        <button onClick={closePopUp} className={styles.yesButton}>
          Yes
        </button>
        <button onClick={toggleClick} className={styles.noButton}>
          No
        </button>
      </div>
    </div>
  </div>
);

CancelAppointmentPopUp.propTypes = {
  toggleClicked: PropTypes.func.isRequired,
  closePopUp: PropTypes.func.isRequired,
};

export default CancelAppointmentPopUp;
